module.exports = __webpack_public_path__ + "img/ex-logo@2x.f7cae240.png";